"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettlementRepository = void 0;
const httpRepository_1 = __importDefault(require("./httpRepository"));
exports.SettlementRepository = {
    getListForWallet: async ({ virtualCardId }) => {
        const response = await httpRepository_1.default.tradeshiftGo().get(`/rest/payments/settlements?virtualCardId=${virtualCardId}`);
        return response.data;
    },
    getReceiptInfo: async (settlementId) => {
        const response = await httpRepository_1.default.tradeshiftGo().get(`/rest/payments/settlements/${settlementId}/receipt`);
        return response.data;
    },
    removeReceipt: async ({ settlementId }) => {
        return await httpRepository_1.default.tradeshiftGo().delete(`/rest/payments/settlements/${settlementId}/receipt`);
    },
    upload: async ({ file, url }) => {
        const data = new FormData();
        data.append('file', file);
        const response = await httpRepository_1.default.tradeshiftGoMulti().post(url, data);
        return response.data;
    },
    viewReceipt: async ({ receiptId }) => {
        const response = await httpRepository_1.default.tradeshiftBlobRequest().get(`/rest/payments/receipts/${receiptId}/image`);
        return response.data;
    },
    getSettlementList: async ({ month, year, teamId, type }) => {
        if (Number.isInteger(Number(month)) && Number(month) >= 0 && Number.isInteger(Number(year)) && Number(year) >= 0) {
            const baseUrl = `/rest/payments/settlements/info?month=${month}&year=${year}`;
            const urlWithTeamId = teamId ? `${baseUrl}&teamId=${teamId}` : baseUrl;
            const url = type ? `${urlWithTeamId}&type=${type}` : urlWithTeamId;
            const response = await httpRepository_1.default.tradeshiftGo().get(url);
            return response.data;
        }
        else {
            return [];
        }
    },
};
